import { getWithAuth } from '@services/http.service';
import { FEATURE_FLAGS_ME_URL } from '@services/url.service';

export interface MyFeatureFlagsResponse {
  status: boolean;
  message?: string | string[];
  entity?: { features: string[] };
}

export const getMyFeatureFlags = (): Promise<MyFeatureFlagsResponse> => getWithAuth(FEATURE_FLAGS_ME_URL());
